import { useExperimentContext } from "components/ExperimentProvider"
import { FeatureFlagContext } from "components/FeatureFlagProvider"
import { ExperimentFlags } from "@shared/utils.experimentation"
import type React from "react"
import { useContext, useEffect, useRef } from "react"

type flagValueType = string | number | boolean | undefined | null
declare global {
  interface Window {
    // https://support.speedcurve.com/docs/rum-js-api#luxadddataname-value
    LUX: {
      addData: (key: string, value: flagValueType) => void
    }
  }
}

export const SpeedCurveABTestTracking: React.FC = () => {
  const { getValue } = useExperimentContext()

  const { ldClient } = useContext(FeatureFlagContext)
  // Add this to prevent sending the same flags multiple times due to re-renders.
  const hasSent = useRef(false)

  useEffect(() => {
    if (!ldClient || hasSent.current) return
    hasSent.current = true
    const experimentFlags = Object.values(ExperimentFlags)
    const experimentValues: { flag: string; value: flagValueType }[] = []

    // add client side flags
    const allFlags = ldClient.allFlags()
    const clientSideFlags = Object.keys(allFlags)
    clientSideFlags.forEach((flag) => {
      experimentValues.push({ flag, value: allFlags[flag] })
    })

    // add page level experiment flags
    experimentFlags.forEach((flag) => {
      const value = getValue(flag)
      const hasFlag = experimentValues.some(
        (experiment) => experiment.flag === flag
      )
      if (!hasFlag) experimentValues.push({ flag, value })
    })

    // send experiment flags to SpeedCurve
    experimentValues.forEach(({ flag, value }) => {
      window.LUX.addData(flag, value)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ldClient])

  return null
}
